import axios from 'axios';
import moment from 'moment';
import Addons from './Addons';
import Licenses from './Licenses';
export default class MyPlan{
    constructor(team){
        this.team=team;
        //current plan section
        this.planNameHtml=$("#my-plan-name");
        this.planAmountHtml=$("#my-plan-amount");

        //active addons section
        this.planAddonsList=$("#my-plan-addons-list");
        this.planAddonsTotal=$("#my-plan-addons-total");
        this.planAddonsAddButton=$("#my-plan-add-addons");
        this.planNoAddonsHtml=$("#my-plan-no-addons");
        this.addonsCountHtml=$("#my-plan-addons-count");

        //active licenses section

        this.planLicensesList=$("#my-plan-licenses-list");
        this.planLicensesTotal=$("#my-plan-licenses-total");
        this.licensesManagerButton=$("#my-plan-add-licenses");
        this.planNoLicensesHtml=$("#my-plan-no-licenses");
        this.licensesCountHtml=$("#my-plan-licenses-count");

        //upcoming invoice
        this.upcomingInvoiceItemsHtml=$("#my-plan-upcoming-invoice-items");
        this.upcomingInvoiceTotalsHtml=$("#my-plan-upcoming-invoice-totals");
        this.upcomingInvoiceNextPaymentHtml=$("#upcoming-invoice-payment");

        //invoices list

        this.invoicesListHtml=$("#profile-invoices-list");

        //payment methods list

        this.paymentMethodsListHtml=$("#payment-methods-list");
        this.addonManager;
        this.licenseManager;
        this.plan;
        this.subscription={};

        this.trialAlert=$("#trialing-alert");
        this.trialAlertMessage=$("#trial-alert-message");
        this.accountDeleteMessage=$("#account-delete-alert");
        this.upgradePlanId="/#plans";

    };
    load(){
        this.getPlan();
        this.getUpcomingInvoice();
        this.getInvoices();
        this.getPaymentMethods();
        this.planAddonsAddButton.on('click',()=>{
            if(this.plan && this.plan.teamMember){
                //null
            }else{
                this.addonManager=new Addons(this);
                this.addonManager.load();
                this.addonManager.onClose=(success)=>{
                    if(success && this.team){
                        this.team.onLoad();
                    }
                    this.addonManager=undefined;
                }
            }
        });
        $('#addon-manager-modal').on('hidden.bs.modal', ()=>{
            this.addonManager=undefined;
        })

        this.licensesManagerButton.on('click',()=>{
            console.log("licenses manager click")
            if(this.plan && this.plan.teamMember){
                //null
            }else{
                this.licenseManager=new Licenses(this);
                this.licenseManager.load();
                this.licenseManager.onClose=(success)=>{
                    if(success){
                        this.getPlan();
                    }
                    this.licenseManager=undefined;
                }
            }
        });
        $('#license-manager-modal').on('hidden.bs.modal', ()=>{
            this.licenseManager=undefined;
        })

    }
    renderCurrentPlan(plan){
        console.log("rendering plan",plan)
        this.planNameHtml.html(`${plan.name}${plan.is_free ? ' Plan' : ''}${plan.teamMember ? ' (Member)': this.subscription.trial ? ' (Trial)':''}`);
        this.planAmountHtml.html(plan.teamMember ? '' : `$${plan.amount}<small class="text-muted">/${plan.interval}</small>`)
        if(this.subscription.trial){
            this.showTrialAlert(`Your trial period will end on ${this.subscription.trial_end}.`);
        }else if(this.subscription.canceled){
            this.showTrialAlert(`Your subscription will end on ${this.subscription.cancel_at}.`);
            if(this.subscription.account_delete){
                this.showAccountDeleteMessage(`Your account will be deleted on ${this.subscription.cancel_at}.`)
            }
        }else if(this.subscription.incomplete){
            this.showPaymentAlert(`Payment failed. Please select a valid payment method to continue using the ${plan.name} plan.`);
        }else{
            this.hideTrialAlert();
        }
        if(this.subscription.is_free || this.subscription.canceled || this.subscription.teamMember){
            $("#cancel-plan-button").remove();
        }
    };

    showTrialAlert(message){
        this.trialAlert.html(`<div role="alert" class="fade alert alert-info show w-100">
        <svg width="1em" height="1em" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-info me-1">
            <g>
                <circle cx="12" cy="12" r="10"></circle>
                <line x1="12" y1="16" x2="12" y2="12"></line>
                <line x1="12" y1="8" x2="12.01" y2="8"></line>
            </g>
        </svg>
        <span id="trial-alert-message">${message}</span>
    </div>`);
    this.trialAlert.removeClass('d-none');
    };

    showPaymentAlert(message){
        this.trialAlert.html(`<div role="alert" class="fade alert alert-danger show w-100">
        <svg width="1em" height="1em" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-info me-1">
            <g>
                <circle cx="12" cy="12" r="10"></circle>
                <line x1="12" y1="16" x2="12" y2="12"></line>
                <line x1="12" y1="8" x2="12.01" y2="8"></line>
            </g>
        </svg>
        <span id="trial-alert-message">${message}</span>
    </div>`);
    this.trialAlert.removeClass('d-none');
    };

    hideTrialAlert(){
        this.trialAlert.html('');
        this.trialAlert.addClass('d-none') 
    };

    showAccountDeleteMessage(message){
        this.accountDeleteMessage.html(`
                <div role="alert" class="fade alert alert-danger show w-100">
                <svg width="1em" height="1em" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-info me-1">
                    <g>
                        <circle cx="12" cy="12" r="10"></circle>
                        <line x1="12" y1="16" x2="12" y2="12"></line>
                        <line x1="12" y1="8" x2="12.01" y2="8"></line>
                    </g>
                </svg>
                <span>${message}</span>
            </div>
        `)
        this.accountDeleteMessage.removeClass('d-none');
    };

    renderAddons(addons){
        if(!addons || !addons.length){
            this.planNoAddonsHtml.removeClass('d-none')
            this.planAddonsList.html('');
            this.addonsCountHtml.html('Add-ons');
            this.planAddonsTotal.html(``);
            return
        }else{
            this.planNoAddonsHtml.addClass('d-none')
            this.addonsCountHtml.html(`Add-ons (${addons.length})`);
        }

        this.planAddonsList.html('');
        let addonTotalAmount=0;
        let addonInterval='month';
        let member=false;
        addons.forEach(addon => {
            if(addon.interval != 'month'){
                addonInterval=addon.interval;
            }
            if(addon.teamMember){
                member=true;
            }
            addonTotalAmount+=parseFloat(addon.amount);
            const addonName=`<div class="col-sm-9 m-auto">
                <div class="item-title">${addon.name} (Add-on) ${ addon.qty > 1 && !addon.teamMember ? 'x '+addon.qty :''}</div>
                <div class="item-desc">${addon.local.description}</div>
            </div>`;
            const addonPrice=`<div class="item-price">$${addon.amount}/${addon.interval}</div>`;
            const addonRemove=$("<button/>",{
                class:"mui-btn mui-btn--fab ml-3",
                html:`<i class="fa fa-times" aria-hidden="true"></i>`
            });
            const addonActions=$("<div/>",{
                class:"col-sm-3 m-auto text-right d-flex align-items-center justify-content-end",
                html:[!addon.teamMember ? addonPrice : '']
            });

            const addonRow=$("<div/>",{
                class:"row",
                html:[addonName,addonActions]
            });
            const addonItem=$("<li/>",{
                class:"list-group-item",
                html:addonRow
            });

            this.planAddonsList.append(addonItem);
        });

        this.planAddonsTotal.html(member ? '' :`$${addonTotalAmount.toFixed(2)}<small class="text-muted">/${addonInterval}</small>`);
    };  
    renderLicenses(licenses){
        if(!licenses || !licenses.length){
            this.planNoLicensesHtml.removeClass('d-none')
            this.planLicensesList.html('');
            this.licensesCountHtml.html('Licenses');
            this.planLicensesTotal.html(``);
            return
        }else{
            this.planNoLicensesHtml.addClass('d-none')
            this.licensesCountHtml.html(`Licenses (${licenses.length})`);
        }
        const periodEnd=moment(this.subscription.period_end);
        this.planLicensesList.html('');
        let licenseTotalAmount=0;
        let licensesTotalCount=0;
        let licenseInterval='month';
        let member=false;
        
        licenses.forEach(license => {
            if(license.interval != 'month'){
                licenseInterval=license.interval;
            }
            if(license.teamMember){
                member=true;
            }
            licensesTotalCount+=license.qty;
            licenseTotalAmount+=parseFloat(license.amount);
            const addonName=`<div class="col-sm-9 m-auto">
                <div class="item-title">${license.name} (License) ${ license.qty > 1 && !license.teamMember ? 'x '+license.qty :''}</div>
                <div class="item-desc">${license.local.description}</div>
                ${ license.cancelled > 0 ? `<small class="invoice-item-desc text-info sm-text-small"><i class="fa fa-info-circle" aria-hidden="true"></i> Additional ${license.cancelled} ${license.name} are available for use until <u>${periodEnd.format('MMM Do')}</u>${periodEnd.format(', YYYY')}</small>` : ''}
            </div>`;
            const addonPrice=`<div class="item-price">$${license.amount}/${license.interval}</div>`;

            const addonActions=$("<div/>",{
                class:"col-sm-3 m-auto text-right d-flex align-items-center justify-content-end",
                html:[!license.teamMember ? addonPrice : '']
            });

            const addonRow=$("<div/>",{
                class:"row",
                html:[addonName,addonActions]
            });
            const addonItem=$("<li/>",{
                class:"list-group-item",
                html:addonRow
            });

            this.planLicensesList.append(addonItem);
        });
        this.licensesCountHtml.html(`Licenses (${licensesTotalCount})`);
        this.planLicensesTotal.html(member ? '' :`$${licenseTotalAmount.toFixed(2)}<small class="text-muted">/${licenseInterval}</small>`);
    }; 
    getPlan(){
        axios.get('/profile/billing/subscription').then(response=>{
            console.log("My plan",response.data)
            const plan=response.data.items ? response.data.items.find(i=>i.type=='License' || i.type=="Plan") : false;
            if(response.data.upgrade_id && response.data.upgrade_id > 0){
                this.upgradePlanId="/plans/pricing/"+response.data.upgrade_id;
            }
            this.renderProducts(response.data.items);
            if(plan){
                this.subscription=response.data;
                this.plan=plan;
                this.renderCurrentPlan(plan);
            }else{
                //no plan
                this.hideTrialAlert();
                $("#cancel-plan-button").remove();

            }
            $('#my-plan-change').attr('href',this.upgradePlanId);
            if(response.data.teamMember || response.data.is_free){
                try {
                    response.data.teamMember && $("#my-plan-change").remove();
                    $("#cancel-plan-button").remove();
                    response.data.teamMember && this.planAddonsAddButton.addClass('d-none');
                } catch (error) {
                    
                }
            }
            // if(!response.data.teamMember){
            //     if(response.data.addons){
            //         this.renderAddons(response.data.addons);
            //     }
                
            // }else{
            //     if(response.data.myAddons){
            //         this.renderAddons(response.data.myAddons);
            //     }
            // }
        }).catch(err=>{
            console.error('get plan error',err)
        })
    };

    getUpcomingInvoice(){

        axios.get('/profile/billing/subscription/invoices/upcoming').then(response=>{
            console.log("My invoice",response.data)
            if(response.data.lines){
                this.renderUpcomingInvoice(response.data);
            }else{
                this.renderNoUpcomingInvoice();
            }
        }).catch(err=>{
            console.error('get plan error',err)
            this.renderNoUpcomingInvoice();
        })
    };

    renderProducts(items){
        if(!items || items.length==0){
            //no products to show
        }else{
            $("#products-table-list").html('')
            items.sort(function(a,b){return a.type=="Plan" || a.type=="License" ? -1 : 1}).forEach(item=>{
                this.renderProductLine(item);
            })
        }
    };

    renderProductLine(item){
        console.log("Rendering item",item)
        const itemName=`
            <td class="vertical-align-middle border-0 p-0 py-2 pl-2">
            <div class="d-flex flex-column mb-0">
                <span class="invoice-item-name text-invoice-amount">${item.name}</span>
                <small class="invoice-item-desc text-invoice-desc">${item.type}</small>
            </div>
            </td>
        `;

        const itemAvailable=`
            <td class="vertical-align-middle border-0 p-0 py-2">
                <div class="d-flex justify-content-center align-items-start mb-0">
                    <span class="invoice-line-amount text-invoice-amount">${item.assigned}</span>
                </div>
            </td>
        `;

        const itemQty=`
            <td class="vertical-align-middle border-0 p-0 py-2">
                <div class="d-flex justify-content-center align-items-start mb-0">
                    <span class="invoice-line-amount text-invoice-amount">${item.available}</span>
                </div>
            </td>
        `;

        const itemAmount=`
            <td class="vertical-align-middle border-0 p-0 py-2">
                <div class="d-flex justify-content-center align-items-start mb-0">
                    <span class="invoice-line-amount text-invoice-amount">$${item.amount}</span>
                </div>
            </td>
        `;

        const itemAction=$("<a/>",{
            class:'mui-btn mui-btn--flat mui-btn--small mui-btn--primary ml-2 text-500 px-2',
            html:`${item.type=='Add-on' ? 'Manage' : item.has_licenses ? 'Manage' : 'Upgrade'}`,
            href: item.type!="Add-on" && !item.has_licenses ? this.upgradePlanId : '#'
        })

        const actionsContainer=$("<div/>",{
            class:'d-flex justify-content-end align-items-start mb-0',
            html:item.type=="Add-on" && item.teamMember ? '' : itemAction
        });
        if(item.type=="Add-on" && !item.teamMember){
           itemAction.on('click',()=>{
                this.addonManager=new Addons(this);
                this.addonManager.load();
                this.addonManager.onClose=(success)=>{
                    if(success && this.team){
                        this.team.onLoad();
                    }
                    this.addonManager=undefined;
                }
            });
        }else if((item.type=="License" || item.type=="Plan") && !item.teamMember){
            if(item.has_licenses){
                itemAction.on('click',()=>{
                    this.licenseManager=new Licenses(this);
                    this.licenseManager.load();
                    this.licenseManager.onClose=(success)=>{
                        if(success){
                            this.getPlan();
                        }
                        this.licenseManager=undefined;
                    }
                });
            }
        }

        const actionsTd=$('<td/>',{
            class:'vertical-align-top border-0 p-0 py-2 pr-2',
            html: actionsContainer
        })
        
        const itemRow=$("<tr/>",{
            html:[
                itemName,
                itemAvailable,
                itemQty,
                itemAmount,
                actionsTd
            ]
        });

        $("#products-table-list").append(itemRow);
        
    };


    renderUpcomingInvoice(invoice){
        $("#no-upcoming-payments").removeClass('d-flex').addClass('d-none');
        $("#upcoming-invoice-section").removeClass('d-none');
        this.upcomingInvoiceItemsHtml.html('');
        this.period=false;
        const nextPaymentDate=moment(invoice.attempt_date);
        this.upcomingInvoiceNextPaymentHtml.html(`${nextPaymentDate.format("MMM DD, YYYY")}`)
        this.renderInvoiceTotals(invoice);
        invoice.lines.forEach(line=>{
            this.upcomingInvoiceItemsHtml.append(this.renderInvoiceLine(line));
        });
    };

    renderInvoiceLine(line){
        let periodLine=``;
        if((!this.period && line.period_start && line.period_end) ||
        (this.period && this.period.end && moment(line.period_end).diff(this.period.end,'day') != 0)){
            const periodStart=moment(line.period_start);
            const periodEnd=moment(line.period_end);
            periodLine=`<tr><td colspan=4 class="border-0 px-0 py-2"><small class="text-muted text-uppercase">${periodStart.format("MMM DD, YYYY")} - ${periodEnd.format("MMM DD, YYYY")}</small><hr class="mt-1 mb-1"></td></tr>`;
            this.period={
                start: periodStart,
                end:periodEnd
            };
        }
        return `
        ${periodLine}
        <tr>
            <td class="vertical-align-top border-0 p-0">
                <div class="d-flex flex-column mb-1">
                    <span class="invoice-item-name text-invoice-amount">${line.name}</span>
                    <small class="invoice-item-desc text-invoice-desc">${line.description}</small>
                </div>
            </td>
            <td class="vertical-align-top border-0 p-0">
                <div class="d-flex justify-content-end align-items-start mb-1">
                    <span class="invoice-line-amount text-invoice-amount">${line.qty}</span>
                </div>
            </td>
            <td class="vertical-align-top border-0 p-0">
                <div class="d-flex justify-content-end align-items-start mb-1">
                    <span class="invoice-line-amount text-invoice-amount">$${line.unit_amount/100}</span>
                </div>
            </td>
            <td class="vertical-align-top border-0 p-0">
                <div class="d-flex justify-content-end align-items-start mb-1">
                    <span class="invoice-line-amount text-invoice-amount">${line.amount < 0 ? '-' :''}$${Math.abs(line.amount/100)}</span>
                </div>
            </td>
        </tr>`;
    };


    renderInvoiceTotals(invoice){

        const proratedBalance=invoice.starting_balance-invoice.ending_balance;
        //render subtotal
        const subtotal=`<tr>
            <td class="vertical-align-top">
                <div class="d-flex flex-column align-items-end">
                    <span class="invoice-item-name text-invoice-amount">Subtotal</span>
                </div>
            </td>
            <td class="vertical-align-top">
                <div class="d-flex justify-content-end align-items-start">
                    <span class="invoice-line-amount text-bold text-invoice-amount">${invoice.subtotal< 0 ? '-' :''}$${Math.abs(invoice.subtotal/100)}</span>
                </div>
            </td>
        </tr>`;
        const discount=`<tr>
            <td class="vertical-align-top">
                <div class="d-flex flex-column align-items-end">
                    <span class="invoice-item-name text-invoice-amount">Coupon discount</span>
                </div>
            </td>
            <td class="vertical-align-top">
                <div class="d-flex justify-content-end align-items-start">
                    <span class="invoice-line-amount text-bold text-invoice-amount">-${invoice.discount< 0 ? '-' :''}$${Math.abs(invoice.discount/100)}</span>
                </div>
            </td>
        </tr>`;
        const tax=`<tr>
            <td class="vertical-align-top">
                <div class="d-flex flex-column align-items-end">
                    <span class="invoice-item-name text-invoice-desc">Tax</span>
                </div>
            </td>
            <td class="vertical-align-top">
                <div class="d-flex justify-content-end align-items-start">
                    <span class="invoice-line-amount text-bold text-invoice-amount">${invoice.tax< 0 ? '-' :''}$${Math.abs(invoice.tax/100)}</span>
                </div>
            </td>
        </tr>`;

        const total=`<tr>
            <td class="vertical-align-top">
                <div class="d-flex flex-column align-items-end">
                    <span class="invoice-item-name text-invoice-amount">Total</span>
                </div>
            </td>
            <td class="vertical-align-top">
                <div class="d-flex justify-content-end align-items-start">
                    <span class="invoice-line-amount text-bold text-invoice-amount">${invoice.total< 0 ? '-' :''}$${Math.abs(invoice.total/100)}</span>
                </div>
            </td>
        </tr>`;
        const prorated=`<tr>
            <td class="vertical-align-top">
                <div class="d-flex flex-column align-items-end">
                    <span class="invoice-item-name text-invoice-desc">Prorated applied balance</span>
                </div>
            </td>
            <td class="vertical-align-top">
                <div class="d-flex justify-content-end align-items-start">
                    <span class="invoice-line-amount text-bold text-invoice-amount">${proratedBalance< 0 ? '-' :''}$${Math.abs(proratedBalance/100)}</span>
                </div>
            </td>
        </tr>`;

        const amountDue=`<tr>
            <td colspan="2">
                <hr>
            </td>
            </tr>
            <tr>
                <td class="vertical-align-top">
                    <div class="d-flex flex-column align-items-end">
                        <span class="invoice-item-name text-invoice-amount text-lg">Amount due</span>
                    </div>
                </td>
                <td class="vertical-align-top">
                    <div class="d-flex justify-content-end align-items-start">
                        <span class="invoice-line-amount text-bold text-invoice-amount text-lg">${invoice.amount_due< 0 ? '-' :''}$${Math.abs(invoice.amount_due/100)}</span>
                    </div>
                </td>
        </tr>`;

        this.upcomingInvoiceTotalsHtml.html([
            subtotal,
            invoice.discount != 0 ?discount:'',
            tax,
            total,
            invoice.starting_balance != 0 ? prorated : '',
            amountDue
        ]);

    }



    
    getInvoices(){
        axios.get('/profile/billing/subscription/invoices').then(response=>{
            console.log("My invoices",response.data)
            if(response.data.length){
                this.renderMyInvoices(response.data);
            }else{
                this.renderNoInvoices();
            }
        }).catch(err=>{
            console.error('get plan error',err)
        })
    };


    renderMyInvoices(invoices){
        this.invoicesListHtml.html('');
        invoices.forEach(invoice=>{
            const periodStart=moment(invoice.period_start);
            const periodEnd=moment(invoice.period_end);
            const invoiceRow=`<tr>
                <td class="vertical-align-middle" nowrap ><a target="_blank" href="${invoice.url}">${invoice.number}</a></td>
                <td class="vertical-align-middle" nowrap >${periodStart.format("MMM DD")} - ${periodEnd.format("MMM DD, YYYY")}</td>
                <td class="vertical-align-middle">$${invoice.amount_due/100}</td>
                <td class="vertical-align-middle"><span class="badge bg-${invoice.status=="paid" ? 'success' : 'danger'} text-white px-2">${invoice.status}</span></td>
                <td class="vertical-align-middle"><div class="d-flex justify-content-end"><a class="mui-btn mui-btn--flat ml-3 mui-btn--small text-500" target="_blank" href="${invoice.pdf}"><i class="fa fa-download" aria-hidden="true"></i></a></div></td>
            </tr>`;
            this.invoicesListHtml.append(invoiceRow);
        });
    };

    renderNoInvoices(){
        this.invoicesListHtml.html(`<tr>
            <td class="py-0 vertical-align-middle" colspan=5>
                <div class="d-flex w-100 justify-content-center align-items-center flex-column mb-5 mt-5">
                    <img src="/images/profile/invoices.svg" width=120>
                    <p class="invoice-text-desc">No invoices to show</p>
                </div>
            </td>
        </tr>`);
    }
    getPaymentMethods(){
        axios.get('/profile/billing/payment-methods').then(response=>{
            console.log("My payment methods",response.data)
            if(response.data.length){
                this.renderPaymentMethods(response.data);
            }else{
                this.renderNoPaymentMethods();
            }
        }).catch(err=>{
            console.error('get plan error',err)
        })
    };

    renderPaymentMethods(methods){
        this.paymentMethodsListHtml.html('');
        methods.forEach(method=>{
            const methodLogo=`<div class="card-logo sm-w-60px">
                <img src="/images/profile/cards/${method.brand}.png" alt="">
            </div>`;
            const methodDetails=`<div class="card-details">
                <span style="">${method.brand[0].toUpperCase()}${method.brand.slice(1)} ending in ${method.last4}</span>
                <small class="text-invoice-desc">Expires ${method.exp_month}/${method.exp_year}</small>
            </div>`;

            
            const defaultBadge=`<span class="badge bg-secondary text-white px-2">default</span>`;
            const deleteMethod=$("<button/>",{
                class:"mui-btn mui-btn--small mui-btn--flat mui-btn--danger text-500 ml-3",
                html: `<i class="far fa-trash-alt"></i>`
            });
            const makeDefault=$("<button/>",{
                class:"mui-btn mui-btn--small mui-btn--flat mui-btn--primary px-2 text-500",
                html:'Set default',
                style: "min-width:90px"
            });
            
            deleteMethod.on('click',()=>{
                deleteMethod.html(`<i class="fa fa-circle-notch fa-spin" aria-hidden="true"></i>`);
                makeDefault.prop({disabled:true});
                this.paymentMethodDelete(method.id,deleteMethod);
            });
            makeDefault.on('click',()=>{
                makeDefault.html(`<i class="fa fa-circle-notch fa-spin" aria-hidden="true"></i>`);
                deleteMethod.prop({disabled:true})
                this.paymentMethodSetDefault(method.id,makeDefault)
            });

            const methodActions=$("<div/>",{
                class:"card-action",
                html:[method.default ? defaultBadge : makeDefault, !method.default ? deleteMethod : '']
            })
            const methodLine=$("<div/>",{
                class:"d-flex px-3 sm-px-0",
                html:[methodLogo,methodDetails,methodActions]
            });

            const methodColumn=$("<div/>",{
                class:"col-md-12 list-group-item border-bottom-0 px-3",
                html:methodLine
            });

            const methodRow=$("<div/>",{
                class:"row",
                html:methodColumn
            })

            this.paymentMethodsListHtml.append(methodRow);

        });
    };

    renderNoPaymentMethods(){
        this.paymentMethodsListHtml.html(`<div class="d-flex w-100 justify-content-center align-items-center flex-column mb-5">
            <img src="/images/profile/payment-method.svg" width=120>
            <p class="invoice-text-desc">No payment methods to show</p>
        </div>`);
    }

    paymentMethodSetDefault(payment_method_id,button){
        axios.post('/profile/billing/payment-methods/default',{
            payment_method_id:payment_method_id
        }).then(response=>{
            if(response.data.error){
                console.error(response.data);
                button.html('Set default')
            }else{
                this.getPaymentMethods();
            }
        }).catch(err=>{
            console.error('get plan error',err)
        })
    };

    paymentMethodDelete(payment_method_id,button){
        axios.post('/profile/billing/payment-methods/delete',{
            payment_method_id:payment_method_id
        }).then(response=>{
            if(response.data.error){
                console.error(response.data);
                button.html('<i class="fa fa-times" aria-hidden="true"></i>')
            }else{
                this.getPaymentMethods();
            }
        }).catch(err=>{
            console.error('get plan error',err)
        })
    };

    renderNoUpcomingInvoice(){
        $("#no-upcoming-payments").addClass('d-flex').removeClass('d-none');
        $("#upcoming-invoice-section").addClass('d-none');
    }

};